const InputField = ({
  label,
  id,
  type,
  errors,
  register,
  required,
  message,
  className,
  min,
  autoFocus,
  placeholder,
  readOnly,
}) => {
  return (
    <div className={`flex flex-col gap-1 ${className || ""}`}>
      <label htmlFor={id} className="input-label">
        {label}
      </label>

      <input
        type={type}
        id={id}
        placeholder={placeholder}
        className={`input-field ${autoFocus ? "ring-2 ring-brand-500/30" : ""} ${
          errors[id]?.message ? "input-field-error" : ""
        }`}
        {...register(id, {
          required: { value: required, message },
          minLength: min
            ? { value: min, message: "Minimum 6 character is required" }
            : null,
        })}
        readOnly={readOnly}
      />

      {errors[id]?.message && (
        <p className="text-sm font-semibold text-red-500 mt-0">
          {errors[id]?.message}*
        </p>
      )}
    </div>
  );
};

export default InputField;
